import React, { useState } from 'react';
import { Switch } from "../atoms/Switch";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUser } from '@shared/store/auth.duck';
import { selectIsLoading, setSync } from '@features/settings/store/outlookSync.duck';
import { failureNotification } from '@shared/store/notification.duck';
import { SimpleSpinner } from "../atoms/SimpleSpinner";
import { requestCalendarAccess } from '@shared/auth/authMachine.duck';

export default function CalendarSwitch() {
  const dispatch = useDispatch();
  const current = useSelector(selectCurrentUser);
  const isLoading = useSelector(selectIsLoading);
  const [isAzureLoading, setIsAzureLoading] = useState(false);

  const onChange = async (val: boolean) => {
    if (val) {
      setIsAzureLoading(true);
      try {
        await (dispatch(requestCalendarAccess({ source: 'manual' })) as any).unwrap();
        dispatch(setSync(true));
      } catch (e: any) {
        dispatch(failureNotification('Failed to enable calendar sync'))
      } finally {
        setIsAzureLoading(false);
      }
    } else {
      dispatch(setSync(false));
    }
  }

  return (
    <React.Fragment>
      {(isLoading || isAzureLoading) ? <SimpleSpinner size={16} /> : <Switch value={!!current?.enableOutlookSync} label="" onChange={onChange}/>}
    </React.Fragment>
  );
}
